import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import ReportsScreen from '../screen'
import ReportRoutes from '../../report/routes'

const ReportsRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.REPORTS} component={ReportsScreen} />
            <ReportRoutes />
        </React.Fragment>
    )
}

export default ReportsRoutes